import React from "react";
import { ArrowRight, Scale } from "lucide-react";

const fmtAnswer = (it) => {
  if (!it.answered) return "Not answered";
  const v = it.raw_value;
  if (typeof v === "boolean") return v ? "Yes" : "No";
  if (/^(yes|true)$/i.test(String(v))) return "Yes";
  if (/^(no|false)$/i.test(String(v))) return "No";
  return it.indicator_id === "ind_student_perf_11" ? `${v}%` : String(v);
};
const Delta = ({ a, b }) => (
  <span className="whitespace-nowrap"><span className="text-[#6b7280]">{a ?? "—"}</span> <ArrowRight className="inline h-3 w-3 text-[#9ca3af]" aria-label="to" /> <b className="text-[#111827]">{b ?? "—"}</b></span>
);

export const ScoringComparisonCard = ({ comparison, onJump }) => {
  if (!comparison) return null;
  return (
    <section aria-labelledby="scmp-h" className="mb-4 rounded-lg border border-[#e5e7eb] bg-white px-4 py-3" data-testid="scoring-comparison-card">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h2 id="scmp-h" className="inline-flex items-center gap-2 text-[14px] font-semibold text-[#111827]"><Scale className="h-4 w-4 text-[#007a9e]" aria-hidden="true" /> Old vs new scoring · same answers</h2>
        <span className="text-[13px]" data-testid="scoring-comparison-overall">Overall <Delta a={comparison.overall_old} b={comparison.overall_new} /></span>
      </div>
      <div className="mt-2 overflow-x-auto">
        <table className="w-full text-[13px]">
          <thead><tr className="text-left text-[11.5px] uppercase tracking-wide text-[#6b7280]"><th className="py-1 pr-3 font-semibold">Question</th><th className="py-1 pr-3 font-semibold">Answer</th><th className="py-1 font-semibold">Points <span className="hidden sm:inline">v1.0 → v1.1</span></th></tr></thead>
          <tbody>
            {comparison.items.map((it) => (
              <tr key={it.indicator_id} className="border-t border-[#f0f1f3]" data-testid={`scoring-comparison-row-${it.indicator_id}`}>
                <td className="py-1.5 pr-3">
                  {onJump ? <button type="button" onClick={() => onJump(it.indicator_id)} className="text-left font-medium text-[#005f7b] underline underline-offset-2" data-testid={`scoring-comparison-jump-${it.indicator_id}`}>{it.indicator_name}</button> : it.indicator_name}
                </td>
                <td className="py-1.5 pr-3">{fmtAnswer(it)}</td>
                <td className="py-1.5">{it.answered ? <Delta a={`${it.old_points}/${it.max_points}`} b={`${it.new_points}/${it.max_points}`} /> : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-[12.5px] text-[#4b5563]" data-testid="scoring-comparison-pillars">
        {comparison.pillars.map((p) => <span key={p.id}>{p.name} <Delta a={p.old} b={p.new} /></span>)}
      </p>
    </section>
  );
};
